import * as React from 'react';
import { UIHeading4, UIText2 } from '@cian/ui-kit';
import * as styles from './DiscountBanner.css';

export const DiscountBanner = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['icon-container']}></div>
      <div className={styles['content']}>
        <UIHeading4>Скидка на размещение</UIHeading4>
        <div className={styles['description-wrapper']}>
          <UIText2>Подобные объекты в этом районе сейчас можно сдать быстрее</UIText2>
        </div>
      </div>
    </div>
  );
};
